import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X } from "lucide-react";
import { AI2 } from "./api";
import { useEscape } from "./util";

export const FeedbackDialog = ({ msg, onClose, onSaved, isManager }) => {
  useEscape(onClose);
  const [text, setText] = useState("");
  const [scope, setScope] = useState("location");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${AI2}/messages/${msg.id}/feedback`, { rating: "down", correction: text.trim() || null, scope });
      toast.success(data.status === "pending" ? "Thanks. Your correction is waiting for a manager to approve it." : text.trim() ? "Correction saved. Re-answering with it now." : "Thanks for the feedback.");
      if (data.conflicts) toast.warning("This correction conflicts with an existing one. An admin will pick which to keep.");
      onSaved(text.trim(), data.status);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't save feedback");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="scrim" onClick={onClose} data-testid="ai2-feedback-dialog">
      <div className="dialog" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>What's the right answer?</h3>
          <button className="btn btn-ghost btn-sm" style={{ marginLeft: "auto" }} onClick={onClose} aria-label="Close" data-testid="ai2-feedback-close"><X size={16} /></button>
        </div>
        <p className="muted" style={{ fontSize: 13, margin: "0 0 12px" }}>Tell the assistant what it got wrong. It will check this before answering similar questions{isManager ? "" : " once a manager approves it"}.</p>
        <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>Question: <b style={{ color: "var(--text)" }}>{msg.question}</b></div>
        <textarea className="input" rows={4} style={{ width: "100%" }} placeholder="e.g. Late pickup fee is $25 after 6pm, not $15" value={text} onChange={(e) => setText(e.target.value)} data-testid="ai2-feedback-text" />
        <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }} className="tabs" data-testid="ai2-feedback-scope">
          <button className={`tab ${scope === "location" ? "active" : ""}`} onClick={() => setScope("location")} data-testid="ai2-scope-location">This location</button>
          <button className={`tab ${scope === "all" ? "active" : ""}`} onClick={() => setScope("all")} data-testid="ai2-scope-all">All locations</button>
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
          <button className="btn" onClick={onClose} data-testid="ai2-feedback-cancel">Cancel</button>
          <button className="btn btn-primary" disabled={busy} onClick={save} data-testid="ai2-feedback-submit">{busy ? "Saving…" : text.trim() ? "Save correction" : "Just mark as wrong"}</button>
        </div>
      </div>
    </div>
  );
};
